module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-cascader', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "placeholder": "根据地区筛选",
      "options": _vm.regions,
      "filterable": "",
      "props": {
        checkStrictly: true
      },
      "size": "mini"
    },
    on: {
      "change": _vm.RegionChangeSearch
    },
    model: {
      value: (_vm.selected_params.regions_value),
      callback: function($$v) {
        _vm.$set(_vm.selected_params, "regions_value", $$v)
      },
      expression: "selected_params.regions_value"
    }
  }), _vm._v(" "), (_vm.exist_shop) ? _c('el-select', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: (_vm.handleScroll),
      expression: "handleScroll"
    }],
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "placeholder": _vm.desc,
      "filterable": "",
      "remote": "",
      "remote-method": _vm.remoteMethod,
      "clearable": "",
      "size": "mini"
    },
    model: {
      value: (_vm.selected_params.shop_id),
      callback: function($$v) {
        _vm.$set(_vm.selected_params, "shop_id", $$v)
      },
      expression: "selected_params.shop_id"
    }
  }, [_vm._l((_vm.list), function(item) {
    return (_vm.wxshops) ? _c('el-option', {
      key: item.wxShopId,
      attrs: {
        "label": item.storeName,
        "value": item.wxShopId
      }
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.list), function(item) {
    return (_vm.distributors) ? _c('el-option', {
      key: item.distributor_id,
      attrs: {
        "label": item.name,
        "value": item.distributor_id
      }
    }) : _vm._e()
  })], 2) : _c('div', {
    staticStyle: {
      "width": "33%",
      "display": "inline-block",
      "text-align": "center"
    }
  }, [_vm._v("暂无符合要求的店铺")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "33%",
      "display": "inline-block"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.init
    }
  }, [_vm._v("重置")])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6612f092", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6612f092"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shopSelect/index.vue
// module id = 2786
// module chunks = 0